<template>
  <div class="home pay">
    <van-nav-bar left-text="上社保 找亿企评" @click-left="onClickLeft">
      <a :href="'tel:' + phone" slot="right" class="hd-title"><i class="tel-icon"></i>{{phone}}</a>
    </van-nav-bar>

    <section class="social-methods">
        <div class="canbaoInfo">
          <div class="social-pay">
            <h4><span class="detail-label">订单编号：</span>{{orderId}}</h4>
            <h4><span class="detail-label">参保确认：</span>{{cityName}}</h4>
            <h4><span class="detail-label">参保内容：</span>{{insContValue}}</h4>
            <h4><span class="detail-label">联系人：</span>{{contactTel}}</h4>
            <ul class="payDetailList clearfix" v-for="(item, index) in socialList" :key="index">
              <li>{{item.name}}</li>
              <li class="w-240">{{item.userId}}</li>
              <li>{{item.monthNum}}个月</li>
              <li class="w-88">{{item.contentType==1?'新参保':'续缴'}}</li>
              <li class="w-88">{{item.cityConfigName}}</li>
            </ul>
            <h4>费用合计：</h4>
            <h5><span class="detail-label">代收费用：</span><span>¥{{charge}}</span></h5>
            <h5><span class="detail-label">服务费：</span><span>¥{{serviceCharge}}</span></h5>
            <h4><span class="detail-label">费用合计：</span><span class="totalNum">¥{{totalPrice}}</span></h4>
          </div>
        </div>
    </section>

    <section class="pay-methods">
      <div class="pay-box">
        <h4 class="success-tips">订单支付成功</h4>
        <h3 class="success-price">¥{{totalPrice}}</h3>
        <p>
          我们会尽快处理您的订单，<br/>
          如处理过程中有问题，我们客服会主动联系您。
        </p>
        <h4 class="backHome" @click="onClickLeft">返回首页</h4>
      </div>
    </section>

  </div>
</template>

<script>
  import Qs from 'qs'
  import Title from '../../components/Title/Title'
  export default {
    name: 'Home',
    components: {
      Title
    },
    data () {
      return {
        phone: '400-110-9919',
        orderId: "", //订单号
        cityName:"",//最终选中的地区的名字
        cityCode:"",//最终选中的地区的id
        insContValue: "",  //参保内容显示的内容
        insContId: "",
        contactTel: "",
        curSerIndex: "",
        socialList: [],
        sureCbInfo: true,
        charge: "", //代收费用
        serviceCharge: "", //服务费
        totalPrice: "", //合计费用
      }
    },
    methods: {
      onClickLeft() {
        this.$router.push({name: 'Home'});
      },
      getPayInfo() {
        let orderId = this.$route.query.orderId;
        let params = {
          orderId: orderId
        };
        let strParams = Qs.stringify(params);
        this.$Api.getPayDetail(strParams).then(res => {
          /*console.log(res);*/
          if (res.code == 500 || res.code == '500') {
            this.$toast.fail('获取订单失败，请稍后重试');
          } else {
            let orderAndUserVO = res.orderAndUserVO;
            this.orderId = orderAndUserVO.orderId;
            this.cityName = orderAndUserVO.cityName;
            this.insContValue = orderAndUserVO.typeName;
            this.contactTel = orderAndUserVO.phone;
            this.socialList = res.orderAndUserVO.orderUserListVOList;
            this.charge = orderAndUserVO.collectionFee
            this.serviceCharge = orderAndUserVO.serviceFee;
            this.totalPrice = orderAndUserVO.totalFee;
          }
        }).catch(err => {
          this.$toast("服务器错误，请稍后重试！");
        });
      }
    },
    mounted() {
      this.getPayInfo();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import "./index.css";
</style>



// WEBPACK FOOTER //
// src/layout/success/index.vue